module.exports = __webpack_public_path__ + "static/img/rule_content.5b5e560a.png";